module.exports = __webpack_public_path__ + "img/rejectedBlue.496ad159.png";